import React from 'react';
import { Check, GraduationCap } from 'lucide-react';
import { Button } from './ui/button';
import { aboutContent, certificates } from '../data/mock';

const AboutSection = ({ onBookingClick }) => {
  return (
    <section id="about" className="py-16 md:py-24 bg-white section-surface relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-sand-100/70 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16 lg:items-center">
          <div className="order-1 lg:hidden">
            <p className="mb-2 text-xs font-medium uppercase tracking-[0.3em] text-teal-600">
              {aboutContent.title}
            </p>
            <h2 className="text-3xl font-serif leading-tight text-stone-800">
              {aboutContent.subtitle}
            </h2>
          </div>

          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src={aboutContent.image}
                  alt="Психолог Ирина Лазарева"
                  width="800"
                  height="500"
                  loading="lazy"
                  decoding="async"
                  className="h-[360px] w-full object-cover md:h-[500px]"
                />
              </div>
              
              {/* Experience Badge */}
              <div className="absolute bottom-4 right-4 rounded-2xl bg-teal-700 p-4 text-white shadow-xl md:-bottom-6 md:-right-6 md:p-6">
                <p className="text-4xl font-serif font-bold">30+</p>
                <p className="text-teal-100 text-sm">Лет практики</p>
              </div>

              {/* Decorative Element */}
              <div className="absolute -left-6 -top-6 -z-10 hidden h-full w-full rounded-2xl border-2 border-sand-200 md:block" />
            </div>
          </div>

          {/* Content Side */}
          <div className="order-3 space-y-8 lg:order-2">
            <div className="hidden lg:block">
              <p className="text-teal-600 font-medium tracking-[0.3em] uppercase text-xs mb-2">
                {aboutContent.title}
              </p>
              <h2 className="text-3xl md:text-4xl font-serif text-stone-800 leading-tight">
                {aboutContent.subtitle}
              </h2>
            </div>

            <div className="space-y-4">
              <p className="text-stone-600 leading-relaxed text-lg">
                {aboutContent.description}
              </p>
              <p className="text-stone-600 leading-relaxed">
                {aboutContent.additionalInfo}
              </p>
            </div>

            {/* Highlights */}
            <div className="grid sm:grid-cols-2 gap-4">
              {aboutContent.highlights.map((highlight, index) => (
                <div key={index} className="flex items-center gap-3 bg-sand-50 rounded-xl p-4 border border-sand-200">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="text-teal-600" size={16} />
                  </div>
                  <span className="text-stone-700 font-medium text-sm">{highlight}</span>
                </div>
              ))}
            </div>

            <Button
              onClick={() => onBookingClick?.()}
              className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-6 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transition-all"
            >
              Записаться на консультацию
            </Button>
          </div>
        </div>

        {/* Certificates Section */}
        <div className="mt-16 md:mt-24">
          <div className="text-center mb-10 md:mb-12">
            <p className="text-teal-600 font-medium tracking-wide uppercase text-sm mb-2">
              Квалификация
            </p>
            <h3 className="text-2xl md:text-3xl font-serif text-stone-800">
              Образование и сертификаты
            </h3>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {certificates.map((cert) => (
              <div
                key={cert.id}
                className="bg-gradient-to-br from-sand-50 to-white border border-sand-200 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                    <GraduationCap className="text-teal-600 group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-stone-800 mb-1">{cert.title}</h4>
                    <p className="text-teal-600 text-sm font-medium">{cert.institution}</p>
                    <p className="text-stone-500 text-sm mt-1">{cert.specialization}</p>
                    <p className="text-stone-400 text-xs mt-2">{cert.year}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
